import * as React from "react"
import { cn } from "@/lib/utils"

export interface WorkoutParameterRowProps {
  label: string
  control: React.ReactNode
  isSecondary?: boolean
  className?: string
}

export function WorkoutParameterRow({ 
  label, 
  control, 
  isSecondary = false, 
  className 
}: WorkoutParameterRowProps) {
  const labelId = React.useId()

  return (
    <div 
      className={cn(
        "grid grid-cols-[64px_1fr] items-center gap-2",
        "sm:grid-cols-[76px_minmax(0,260px)]",
        "lg:grid-cols-[84px_minmax(0,300px)]",
        className
      )}
    >
      <label 
        id={labelId}
        className={cn(
          "text-xs font-medium uppercase tracking-wide",
          isSecondary ? "text-neutral-400" : "text-neutral-500"
        )}
      >
        {label}
      </label>
      {/* Control container with fixed/clamped width */}
      <div 
        className="w-full"
        aria-labelledby={labelId}
      >
        {control}
      </div>
    </div>
  )
}

WorkoutParameterRow.displayName = "WorkoutParameterRow"
